import { enhanceCanvasWithSpellCheck } from './canvasSpellCheckHandler';

/**
 * Initialize custom controls for spell check
 * Should be called after canvas is initialized
 * This now only enhances the canvas instance without modifying prototypes
 */
export const initCustomControlsSpellCheck = () => {
  // Enhance the global canvas instance with spell check handling
  if (window.canvas) {
    enhanceCanvasWithSpellCheck(window.canvas);
  }
};
